import React, { useEffect, useState, memo } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Timer from '../../components/Timer/Timer'
import { HIDE_TIMER, SUBMIT_TEST } from '../../constants/actionTypes'
import Button from '../Button/Button'
import PopUpWrapper from '../PopUpWrapper/PopUpWrapper'
import ProgressBar from '../ProgressBar/ProgressBar'
import QuestionSummary from '../QuestionSummary/QuestionSummary'
import stopwatch from '../../assets/stopwatch_2.svg'
import './CloseTestConfimation.css'
import { isInPhoneOrTablet } from '../../utils/common/isInPhoneOrTablet'
import { handleFullscreen } from '../../views/InstructionsPage/helper'
import Spinner from '../../components/Spinner/Spinner'
import { EVENT_NAMES } from 'constants/eventNames'
import { trackEvent } from 'utils/analyticsService'
import { ANALYTICS_KEYS } from 'constants/analytics-keys'

const mapStateToProps = (state) => {
    return {
        queryparam: state.queryparam,
        instructions: state.instructions,
        testStatus: state.testStatus,
        current_question: state.current_question,
        time: state.timer,
        usertestid: state.testStatus,
        testData: state.testpanel,
        completion: state.completion,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onSubmitTest: (payload) => dispatch({ type: SUBMIT_TEST, payload }),
        hideTimer: (payload) => dispatch({ type: HIDE_TIMER, payload }),
    }
}

const CloseTestConfimation = (props) => {
    const { t } = useTranslation()
    const [timer, setTimer] = useState()
    const [active, setActive] = useState(0)
    const [loading, setLoading] = useState(false)
    const [showError, setshowError] = useState(false)
    const [tData, settData] = useState([])
    const isSubmitted = JSON.parse(sessionStorage.getItem('isSubmitted')) ?? false
    useEffect(() => {
        let timerAddress = timer
        if (props.time.t === 0) {
            clearInterval(timerAddress)
        }

        let tData = Array.isArray(props.testData.questionset)
            ? [...props.testData.questionset]
            : null
        if (Array.isArray(tData)) {
            let answered = 0,
                notAnswered = 0,
                visited = 0,
                markedForReview = 0,
                ansRev = 0,
                notVisited = 0,
                total = 0
            for (let i = 0; i < tData.length; i++) {
                for (let j = 0; j < tData[i].questionList.length; j++) {
                    if (tData[i].questionList[j].question.isAnswered) {
                        answered++
                    }
                    if (tData[i].questionList[j].question.isVisited) {
                        visited++
                    }

                    if (
                        tData[i].questionList[j].question.isMarkedForReview &&
                        !tData[i].questionList[j].question.isAnswered
                    ) {
                        markedForReview++
                    }
                    if (
                        tData[i].questionList[j].question.isMarkedForReview &&
                        tData[i].questionList[j].question.isAnswered
                    ) {
                        ansRev++
                    }
                    if (
                        !tData[i].questionList[j].question.isAnswered &&
                        tData[i].questionList[j].question.isVisited &&
                        !tData[i].questionList[j].question.isMarkedForReview
                    ) {
                        notAnswered++
                    }
                    total++
                }
            }
            notVisited = total - visited
            tData.unshift({
                subject: t('All'),
                summary: [],
            })
            tData[0].summary.push({
                total: total,
                answered: answered,
                notanswered: notAnswered,
                markedForReview: markedForReview,
                notvisited: notVisited,
                answeredAndMarkedForReview: ansRev,
            })
            settData(tData)
        } else {
            setshowError(true)
        }
    }, [])

    async function handleLeaveClick() {
        setLoading(true)

        !(props.isPreview || props.isMock) &&
            (await trackEvent(
                EVENT_NAMES.TAP_LEAVE_TEST_POPUP_WEB,
                'User taps on the leave button on the popup once the user taps on refresh, back or close the browser buttons',
                {
                    [ANALYTICS_KEYS.SUCCESS]: true,

                    [ANALYTICS_KEYS.USER_TEST_ID]:
                        props.testStatus?.testStatus?.data?.userTestId,
                    [ANALYTICS_KEYS.STUDENT_NAME]: props.onSubmitTest.name,
                    // disconnection_time: props.disconnect_timer,
                    [ANALYTICS_KEYS.SECTION_NAME]:
                        props.current_question?.subject[props.current_language],
                },
            ))
        props.handleSubmit(props)
    }

    return (
        <div className="close-test-confirmation-wrapper ">
            {Array.isArray(tData) ? (
                <div className="close-test-confirmation-section">
                    {props.isMock && isSubmitted ? (
                        <></>
                    ) : (
                        <div>
                            <div className="watchTimer">
                                <img
                                    className="stopwatch_img"
                                    alt="stopwatch"
                                    src={stopwatch}
                                ></img>
                                <Timer
                                    timerAddress={timer}
                                    setTimer={setTimer}
                                    id="timer_class"
                                    class={
                                        isInPhoneOrTablet()
                                            ? 'timer_watch_small'
                                            : 'timer_watch'
                                    }
                                />
                            </div>
                            <span className="Completed">
                                {props.completion.completion}% {t('Completed')}
                            </span>
                            <ProgressBar
                                color={'lightgrey'}
                                done={props.completion.completion}
                                opacity={'1'}
                                barcolor={'#00b0f5'}
                                barwidth={'100%'}
                                bgcolor={'#e6e9ea'}
                                barheight="3px"
                            />
                        </div>
                    )}
                    <span
                        className="confirmation-title"
                        style={
                            isInPhoneOrTablet()
                                ? { fontSize: '16px' }
                                : { fontSize: '28px' }
                        }
                    >
                        {t('Do you want to leave the test?')}
                    </span>

                    <div className="tab-container-wrapper-submit">
                        <QuestionSummary
                            isCloseTestConfimationPopUp={true}
                            summary={tData}
                            active={active}
                        />
                    </div>

                    {props.time.t > 0 ? (
                        <>
                            <div
                                className="close-test-confirmation-submit-buttons"
                                style={
                                    isInPhoneOrTablet() && props.showGoBackPopUp
                                        ? { display: 'flex' }
                                        : null
                                }
                            >
                                <Link
                                    to={{
                                        pathname: '/testpanel',
                                        state: { property_id: 'DontShowPopUp' },
                                    }}
                                    className="submit-btn"
                                >
                                    <Button
                                        onClick={() => {
                                            props.setShowGoBackPopUp(false)
                                            props.setDontShowPop &&
                                                props.setDontShowPop(true)
                                            handleFullscreen()
                                        }}
                                        classes="class_btn"
                                        name={'Resume'}
                                    />
                                </Link>
                                <div className="submit-btn">
                                    <Button
                                        onClick={handleLeaveClick}
                                        name={'Leave'}
                                        classes="btn_leave"
                                    />
                                </div>
                            </div>
                        </>
                    ) : (
                        <Link to="/success">
                            <Button
                                name={'OK'}
                                background={'#01b0f5'}
                                color={'#fff'}
                                fontSize={'12px'}
                                height={'40px'}
                                width={'300px'}
                                margin={'auto'}
                            />
                        </Link>
                    )}
                </div>
            ) : showError ? (
                <PopUpWrapper>
                    {t('Oops !! something went wrong ! Please Try again')}
                </PopUpWrapper>
            ) : null}
            {loading ? <Spinner /> : null}
        </div>
    )
}
export default memo(
    connect(mapStateToProps, mapDispatchToProps)(CloseTestConfimation),
)
